
/**
 * Sanitizes search input by removing potentially dangerous characters.
 *
 * @param input - The raw search input string
 * @param shouldTrim - Whether to trim leading/trailing whitespace (use on submit, not during typing)
 * @returns The sanitized input string
 */
export const sanitizeInput = (input: string, shouldTrim: boolean = false): string => {
    if (!input) return '';

    let sanitized = input;

    // Remove semicolons and angle brackets
    sanitized = sanitized.replace(/[;<>*]/g, '');

    if (shouldTrim) {
        sanitized = sanitized.trim();
    }

    return sanitized;
};
